import axiosClient from '../axiosClient';

export const getBlogs = (params) =>
  axiosClient.get('/admin/blogs', { params });

export const getBlogDetail = (id) =>
  axiosClient.get(`/admin/blogs/${id}`);

export const createBlog = (data) =>
  axiosClient.post('/admin/blogs', data);

export const updateBlog = (id, data) =>
  axiosClient.put(`/admin/blogs/${id}`, data);

export const deleteBlog = (id) =>
  axiosClient.delete(`/admin/blogs/${id}`);
